import React from 'react';
// components
import Input from '../../../components/Input/Input';
import ConnectedRadio from './СonnectedRadio';
// styles
import styles from './ConnectedInput.mod.css';
import classnames from 'classnames/bind';
import FieldError from '../../../components/Form/FieldError';

let cx = classnames.bind(styles);

const ConnectedInput = ({ data, errors, values, setValues, setFieldValue }) => {
  const {
    content: { connected_questions }
  } = data;

  return (
    <div>
      {connected_questions.map(({ id, title, questions }) => (
        <div key={id} className={cx('question-container')}>
          <span className={cx('title')}>{title}</span>
          <div className={cx('container')}>
            {questions.map(question => {
              const type = question.question_type;

              const handleTextChange = e =>
                setFieldValue(id, {
                  ...values[id],
                  [question.id]: e.target.value
                });

              const error = errors[id] && errors[id][question.id];

              switch (type) {
                case 'fixed_radio':
                  return (
                    <ConnectedRadio
                      key={question.id}
                      data={question}
                      id={id}
                      values={values[id]}
                      error={error}
                      setFieldValue={setFieldValue}
                    />
                  );
                case 'text':
                  return (
                    <div key={question.id} className={cx('input-wrapper')}>
                      <span>{question.title}</span>
                      <Input
                        placeholder={
                          question.placeholder || 'Please, type here'
                        }
                        data={question}
                        id={id}
                        invalid={error}
                        value={values[id][question.id].toString()}
                        onChange={handleTextChange}
                      />
                      <FieldError error={error} touched />
                    </div>
                  );
                default:
                  return null;
              }
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default React.memo(ConnectedInput);



// WEBPACK FOOTER //
// ./src/containers/Module/components/ConnectedInput.jsx